// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__4Kvqi","aboutHeading":"About_aboutHeading__BV4iW","aboutLeft":"About_aboutLeft__Co27i","aboutRight":"About_aboutRight__yVemI"};